/**
 * Enum for column sorting options.
 */
enum ColumnSortMethod {
  UNSORTED,
  ASCENDING,
  DESCENDING
}

/**
 * Enum for row lifecycle events
 * @readonly
 * @enum {number}
 * EXPANDED, // row expanded
 * DESTROYED, // table being destroyed
 * COLLAPSED, // row was collapsed
 * VIRTUALIZED_OUT, // user scrolled row out of view, so it destroys
 * DATA_CHANGED, // Parent table's data was reassigned. Row is being destroyed.
 */
enum RowLifecycleEventType {
  EXPANDED,
  DESTROYED,
  COLLAPSED,
  VIRTUALIZED_OUT,
  DATA_CHANGED
}

/**
 * Enum for table lifecycle events
 * @readonly
 * @enum {number}
 * CREATED, // table created
 * DESTROYED // table destroyed
 */
enum TableLifecycleEventType {
  CREATED, // table created
  DESTROYED // table destroyed
}

enum CellRenderType {
  CUSTOM,
  AUTO,
  DEFAULT
}

export class GlobalTableConstants {
  public readonly cellRenderType: any;
  public readonly tableLifecycleEventType: any;
  public readonly rowLifecycleEventType: any;
  public readonly columnSortMethod: any;

  constructor() {
    this.cellRenderType = CellRenderType;
    this.tableLifecycleEventType = TableLifecycleEventType;
    this.rowLifecycleEventType = RowLifecycleEventType;
    this.columnSortMethod = ColumnSortMethod;
  }
}
